import script from "./BacklogActions.vue?vue&type=script&setup=true&lang=js"
export * from "./BacklogActions.vue?vue&type=script&setup=true&lang=js"

import "./BacklogActions.vue?vue&type=style&index=0&id=19e60df1&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e60df1"]])

export default __exports__